<template>
    <div class="sa-list-component">
        <b-form @submit.prevent="onSubmit">
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Nome:</label>
                    <b-form-input v-model="filtro.firstname" type="search" id="denominazione"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Cognome:</label>
                    <b-form-input v-model="filtro.lastname" type="search" id="denominazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Presidio:</label>
                    <b-form-select v-model="filtro.idPresidio" :options="presidiOptions" value-field="value" text-field="text" :value="null" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
                </b-col>
            </b-row>
            <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                    <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </b-form>
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rowsUtenti }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rowsUtenti="rowsUtenti" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(utente)="{ item }">
                        <span>{{ item.firstname }} {{ item.lastname }}</span>
                    </template>
                    <template v-slot:cell(presidio)="{ item }">
                        <span v-for="(presidio, index) in item.presidi" :key="index"
                            >{{ presidio.denominazionePresidio }}
                            <!-- ({{ presidio.denominazioneStruttura }}) --><br
                        /></span>
                    </template>
                    <!-- <template v-slot:cell(struttura)="{ item }">
                        <span>{{ item.denominazioneStruttura }}</span>
                    </template> -->
                    <template v-slot:cell(struttura)="{ item }">
                        <span v-for="(presidio, index) in item.presidi" :key="index">{{ presidio.denominazioneStruttura }} <br /></span>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rowsUtenti }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rowsUtenti="rowsUtenti" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            rowsUtenti: 0,
            perPage: 50,
            currentPage: 1,
            //   pathResource: "/strutturepresidi",
            pathResourcePresidi: "/strutturepresidi",
            pathResource: "/utentipresidi",
            filtro: { idPresidio: null },
            items: [],
            presidiOptions: [],
            utentiPresidi: {},
            listKey: 0,
            activeTabIndex: 0,
            fields: [
                {
                    label: "Utente",
                    key: "utente",
                    sortable: true,
                    // thStyle: "width: 18rem",
                },
                {
                    label: "Presidio",
                    key: "presidio",
                    sortable: true,
                    //thStyle: "width: 18rem",
                },
                {
                    label: "Struttura",
                    key: "struttura",
                    //sortable: true,
                    // thStyle: "width: 18rem",
                },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            me.rowsUtenti = 0;
            /*   let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtro"]) {
                me.filtro = JSON.parse(sessionStorage["filtro"]);
            } */
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    //  me.rowsUtenti = response.data.data.recordsNumber;
                    me.utentiPresidi = {};
                    /* me.items = */ response.data.data.list.forEach((element) => {
                        if (!me.utentiPresidi[element.username]) {
                            me.utentiPresidi[element.username] = {
                                firstname: element.firstname,
                                lastname: element.lastname,
                                presidi: [],
                            };
                        }
                        me.utentiPresidi[element.username].presidi.push({ denominazionePresidio: element.denominazionePresidio, denominazioneStruttura: element.denominazioneStruttura });
                    });

                    me.items = Object.values(me.utentiPresidi);
                    me.rowsUtenti = me.items.length;

                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onEdit(item) {
            let me = this;
            me.$router.push("strutturapresidi/edit/" + item.id);
        },
        onView(item) {
            let me = this;
            me.$router.push("strutturapresidi/view/" + item.id);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare il profilo  " + item.descrizione)
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                        axios.delete(link + item.id).then(() => {
                            me.loadData();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onReset() {
            let me = this;
            me.filtro = { idPresidio: null };
            me.loadData();
        },
        onSubmit() {
            let me = this;
            me.loadData();
        },
        loadPresidi() {
            let me = this;
            me.presidiOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.rowsUtenti = response.data.data.recordsNumber;
                    //me.listaStrutture = response.data.data;
                    //  me.cont++;
                    response.data.data.list.forEach((element) => {
                        me.presidiOptions.push({
                            value: element.id,
                            text: element.denominazione,
                        });
                    });
                    me.presidiOptions.unshift({
                        value: null,
                        text: "-Seleziona Struttura-",
                    });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
    },
};
</script>
<style></style>
